import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface OrderImageUploadResponse {
  message: string;
  image: {
    id: number;
    originalName: string;
    mimeType: string;
    size: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class OrderImageService {
  constructor(private readonly http: HttpClient) {}

  upload(orderId: string, image: File): Observable<OrderImageUploadResponse> {
    const formData = new FormData();
    formData.append('image', image, image.name);

    return this.http.post<OrderImageUploadResponse>(
      `/api/orders/${encodeURIComponent(orderId)}/images`,
      formData
    );
  }
}